import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitogoacabservice() {



    const cardData = {

keyword: "Navi Mumbai to Goa Cab Service",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai to Goa Cab Service for long-distance travel, family vacations, group tours, honeymoon trips, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and safe highway driving through the scenic Mumbai–Goa route, we ensure a smooth, comfortable, and hassle-free journey to Goa.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of the most popular beaches in North Goa, known for water sports, beach shacks, nightlife, and lively tourist activities throughout the year."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is often called the Queen of Beaches in Goa and is famous for its long coastline, shopping stalls, water sports, and vibrant tourist crowd."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is known for its rocky shoreline, flea market, sunset views, and relaxed hippie vibe, making it a favorite among international and domestic travelers."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is a peaceful and less crowded beach in North Goa, ideal for relaxation, water sports, and scenic coastal walks."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved Portuguese fort overlooking the Arabian Sea, famous for its lighthouse, sea views, and historical significance."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa, known for its baroque architecture and sacred religious importance."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India’s tallest and most spectacular waterfalls, located on the Goa-Karnataka border and surrounded by dense forest beauty."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is known for its calm waters, scenic beauty, beach huts, and peaceful environment perfect for relaxing vacations."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort offers stunning views of Vagator Beach and is a popular photography and sunset viewpoint made famous by Bollywood movies."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia, known for its Portuguese-Gothic architecture and historical importance in Old Goa."
    }
],



services: [
{
name: "Navi Mumbai to Goa Cab Service",
description: "Navi Mumbai to Goa Cab Service by 1Touch Cabs offers safe, comfortable, and reliable long-distance travel for families, couples, corporate travelers, and tourists heading to Goa. Our service includes a wide range of well-maintained vehicles such as Sedan, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, Luxury Cars, and Tempo Traveller options. With experienced chauffeurs skilled in highway driving via the Mumbai–Goa route, we ensure a smooth, scenic, and stress-free journey. We provide 24x7 booking support, transparent pricing, doorstep pickup, luggage assistance, and flexible one-way or round-trip options, making your Navi Mumbai to Goa travel convenient, safe, and enjoyable.",
},
{
name: "Navi Mumbai to Goa Cab",
description: "Navi Mumbai to Goa Cab service provides dependable intercity transportation for passengers traveling to Goa for vacations, business trips, or family holidays. 1Touch Cabs ensures clean vehicles, professional drivers, flexible pickup options, and a comfortable long-distance journey at affordable pricing.",
},
{
name: "Navi Mumbai to Goa Taxi Service",
description: "Navi Mumbai to Goa Taxi Service offers reliable and safe transportation with experienced chauffeurs and well-maintained air-conditioned vehicles. 1Touch Cabs focuses on punctual service, smooth highway travel, and customer satisfaction for all types of travelers.",
},
{
name: "Navi Mumbai to Goa Taxi",
description: "Navi Mumbai to Goa Taxi service provides convenient and comfortable travel solutions for individuals, families, and groups. 1Touch Cabs ensures affordable fares, professional drivers, and stress-free travel to Goa from Navi Mumbai.",
},
{
name: "Navi Mumbai to Goa One Way Cab",
description: "Navi Mumbai to Goa One Way Cab service offers budget-friendly travel without return fare charges. 1Touch Cabs provides economical pricing, flexible pickup timing, and comfortable vehicles for one-way travelers heading to Goa.",
},
{
name: "Navi Mumbai to Goa Round Trip Cab",
description: "Navi Mumbai to Goa Round Trip Cab service is ideal for planned vacations and return journeys. 1Touch Cabs offers customized packages, experienced chauffeurs, and comfortable vehicles ensuring a smooth round-trip travel experience.",
},
{
name: "Navi Mumbai to Goa Outstation Cab",
description: "Navi Mumbai to Goa Outstation Cab service ensures safe and reliable long-distance travel with professional drivers and well-maintained vehicles. 1Touch Cabs provides transparent pricing and comfortable highway journeys.",
},
{
name: "Navi Mumbai to Goa Innova Cab",
description: "Navi Mumbai to Goa Innova Cab service offers spacious and comfortable travel for families and groups. 1Touch Cabs provides well-maintained Innova vehicles, experienced chauffeurs, and smooth highway rides for a relaxed journey.",
},
{
name: "Navi Mumbai to Goa Innova Crysta Cab",
description: "Navi Mumbai to Goa Innova Crysta Cab service delivers premium comfort with luxury seating, ample luggage space, and smooth long-distance travel. 1Touch Cabs ensures a high-quality and enjoyable journey experience.",
},
{
name: "Navi Mumbai to Goa Ertiga Cab",
description: "Navi Mumbai to Goa Ertiga Cab service offers affordable and comfortable transportation for small families and groups. 1Touch Cabs ensures clean vehicles, safe driving, and budget-friendly intercity travel.",
},
{
name: "Navi Mumbai to Goa Sedan Cab",
description: "Navi Mumbai to Goa Sedan Cab service provides economical and comfortable travel for individuals and couples. 1Touch Cabs offers well-maintained sedans and professional chauffeurs for a smooth journey.",
},
{
name: "Navi Mumbai to Goa SUV Cab",
description: "Navi Mumbai to Goa SUV Cab service provides spacious and powerful vehicles ideal for families and group travel. 1Touch Cabs ensures comfort, safety, and smooth highway driving for long journeys.",
},
{
name: "Navi Mumbai to Goa Private Cab",
description: "Navi Mumbai to Goa Private Cab service offers exclusive transportation with dedicated vehicles and personalized travel schedules. 1Touch Cabs ensures privacy, comfort, and flexibility throughout the journey.",
},
{
name: "Navi Mumbai to Goa Family Cab",
description: "Navi Mumbai to Goa Family Cab service is designed for safe and comfortable family travel. 1Touch Cabs provides spacious vehicles, professional chauffeurs, and smooth highway journeys for families.",
},
{
name: "Navi Mumbai to Goa Cab Package",
description: "Navi Mumbai to Goa Cab Package includes complete travel solutions with flexible options for one-way and round trips. 1Touch Cabs offers affordable pricing, comfortable vehicles, and customized travel plans.",
},
{
name: "Navi Mumbai to Goa Tour Package by Cab",
description: "Navi Mumbai to Goa Tour Package by Cab provides a complete holiday travel solution including transportation, sightseeing flexibility, and comfortable rides. 1Touch Cabs ensures a memorable Goa travel experience.",
},
{
name: "Affordable Navi Mumbai to Goa Cab",
description: "Affordable Navi Mumbai to Goa Cab service offers budget-friendly travel without compromising comfort and safety. 1Touch Cabs provides economical fares, reliable vehicles, and professional drivers.",
},
{
name: "Luxury Cab Navi Mumbai to Goa",
description: "Luxury Cab Navi Mumbai to Goa service provides premium travel experience with high-end vehicles and professional chauffeurs. 1Touch Cabs is ideal for VIP travelers, honeymoon couples, and corporate clients.",
},
{
name: "AC Cab Navi Mumbai to Goa",
description: "AC Cab Navi Mumbai to Goa service ensures fully air-conditioned comfortable travel for long-distance journeys. 1Touch Cabs provides clean vehicles and smooth rides for a pleasant experience.",
},
{
name: "Best Navi Mumbai to Goa Cab Service",
description: "Best Navi Mumbai to Goa Cab Service by 1Touch Cabs ensures reliable, safe, and comfortable travel with professional chauffeurs, transparent pricing, and excellent customer support.",
},
{
name: "Online Navi Mumbai to Goa Cab Booking",
description: "Online Navi Mumbai to Goa Cab Booking allows quick and easy reservation with instant confirmation. 1Touch Cabs provides multiple vehicle options, flexible scheduling, and 24x7 booking support."
}
],

tableData: [
["Navi Mumbai to Goa Cab Service","Navi Mumbai to Goa Cab"],
["Navi Mumbai to Goa Taxi Service","Navi Mumbai to Goa Taxi"],
["Navi Mumbai to Goa One Way Cab","Navi Mumbai to Goa Round Trip Cab"],
["Navi Mumbai to Goa Outstation Cab","Navi Mumbai to Goa Innova Cab"],
["Navi Mumbai to Goa Innova Crysta Cab","Navi Mumbai to Goa Ertiga Cab"],
["Navi Mumbai to Goa Sedan Cab","Navi Mumbai to Goa SUV Cab"],
["Navi Mumbai to Goa Private Cab","Navi Mumbai to Goa Family Cab"],
["Navi Mumbai to Goa Cab Package","Navi Mumbai to Goa Tour Package by Cab"],
["Affordable Navi Mumbai to Goa Cab","Luxury Cab Navi Mumbai to Goa"],
["AC Cab Navi Mumbai to Goa","Best Navi Mumbai to Goa Cab Service"],
["Online Navi Mumbai to Goa Cab Booking","Navi Mumbai to Goa Outstation Cab"]
],














whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai to Goa Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai to Goa Cab Services for families, couples, tourists, corporate travelers, and vacationers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Perfect Goa Holiday Travel Solution",
        WhyChoosedescription: "Enjoy a hassle-free road trip from Navi Mumbai to Goa while exploring beautiful highways, scenic landscapes, coastal routes, and breathtaking views along the journey."
    },
    {
        WhyChooseheading: "Ideal for Family Vacations and Group Tours",
        WhyChoosedescription: "Whether you are planning a family holiday, honeymoon trip, friends' getaway, corporate outing, or beach vacation, our cab service offers a comfortable travel experience."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day holiday package, or customized Goa tour, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Navi Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, Sanpada, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on Mumbai-Goa highway routes and ensure safe, smooth, and comfortable transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Couples, Families, and Tourist Groups",
        WhyChoosedescription: "From honeymoon couples and small families to large tourist groups and corporate teams, we provide suitable vehicles for every Goa travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Navi Mumbai to Goa Cab Services?",
        answer: "Goa is one of India's most popular tourist destinations known for its beaches, nightlife, churches, forts, water sports, seafood, and holiday experiences."
    },
    {
        question: "Can I book a one-way cab from Navi Mumbai to Goa?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Goa holiday packages."
    },
    {
        question: "Which vehicle is suitable for Navi Mumbai to Goa travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Can families book cabs for Goa vacations?",
        answer: "Yes, many families choose our cab services for comfortable travel to Goa resorts, hotels, villas, beaches, and sightseeing destinations."
    },
    {
        question: "Are Tempo Travellers available for group Goa trips?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, bachelor trips, and tourist groups."
    },
    {
        question: "Can sightseeing places be included during the trip?",
        answer: "Yes, customers can customize their itinerary and visit North Goa, South Goa, beaches, forts, churches, casinos, waterfalls, and other tourist attractions."
    },
    {
        question: "Can pickup be arranged from any Navi Mumbai location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Navi Mumbai."
    },
    {
        question: "Do you provide multi-day Goa tour packages?",
        answer: "Yes, customers can book customized Goa holiday packages with flexible travel schedules and sightseeing plans."
    },
    {
        question: "Is advance booking recommended for Navi Mumbai to Goa travel?",
        answer: "Yes, advance booking is recommended, especially during weekends, long holidays, Christmas, New Year, and peak tourist seasons."
    },
    {
        question: "How can I book a Navi Mumbai to Goa Cab Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Karan Shah",
        feedback:
            "Our Goa vacation started perfectly with Mumbai Airport Cabs. The vehicle was comfortable, the driver was professional, and the entire road journey was enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priti Kulkarni",
        feedback:
            "We booked a family trip from Navi Mumbai to Goa and had an excellent experience. The cab was clean, spacious, and the travel arrangements were handled professionally throughout the journey.",
        rating: 5
    }
];



















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Goa Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-to-goa-cab.jpg",
  "description": "Book Navi Mumbai to Goa cab service for safe, comfortable, and affordable outstation travel. Mumbai Airport Cabs offers reliable one-way and round-trip taxi service with professional drivers, clean AC vehicles, and 24x7 availability for Goa trips.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "9100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/navi-mumbai-to-goa-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Goa Cab Service | Outstation Taxi Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Goa cab service for safe and comfortable outstation travel. Affordable one-way and round-trip taxi with professional drivers."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to Goa Cab Service, Navi Mumbai to Goa Cab, Navi Mumbai to Goa Taxi Service, Navi Mumbai to Goa Taxi, Navi Mumbai to Goa One Way Cab, Navi Mumbai to Goa Round Trip Cab, Navi Mumbai to Goa Outstation Cab, Navi Mumbai to Goa Innova Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitogoacabservice;